import React, { useState, useEffect } from 'react';
import { Header } from '../components/Header/Header';
import { HeroSection } from '../components/HeroSection/HeroSection';
import { Statement } from '../components/Statement/Statement';
import { WhatWeDo } from '../components/WhatWeDo/WhatWeDo';
import { Partners } from '../components/Partners/Partners';
import { Footer } from '../components/Footer/Footer';
import { CVobject } from '../components/CVobject/CVobject';
import { Cookies } from '../components/Cookies/Cookies';
import './landingPage.scss';

export const LandingPage = () => {
  const [timerPopup, setTimerPopup] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setTimerPopup(true);
    }, 2000);
  }, []);

  return (
    <div className="landingPage">
      <Header showLPLinks={true} />
      <HeroSection />
      <Statement />
      <WhatWeDo />
      <CVobject />
      <Partners />
      <Cookies trigger={timerPopup} setTrigger={setTimerPopup} />
      <Footer />
    </div>
  );
};
